import { render } from "./request-form.vue?vue&type=template&id=f9f74712&scoped=true"
import script from "./request-form.vue?vue&type=script&lang=js"
export * from "./request-form.vue?vue&type=script&lang=js"

import "./_request-form.mobile.scss?vue&type=style&index=0&id=f9f74712&lang=scss&scoped=true&external"
import "./_request-form.desktop.scss?vue&type=style&index=1&id=f9f74712&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9f74712"]])

export default __exports__